module.exports = __webpack_public_path__ + "static/media/userProfile.9676a6ea.png";